import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "max-w-[1040px]" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-gray-500"
}

import { computed, onMounted, ref } from 'vue'

import NeueLoading from '@/components/neue/NeueLoading'
import NeueToggle from '@/components/neue/NeueToggle'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import api from '@/store/api'
import { mapRelationship, mapRelationships, mapType } from '@/store/mappers'


export default {
  __name: 'StoreMembershipTiers',
  props: ['id'],
  setup(__props) {

const loading = ref(true)
const props = __props
const store = computed(() => mapRelationship({ type: 'store', id: props.id }))
const tiers = computed(() => mapType('membership_tier'))
const waiting = ref({})

onMounted(async () => {
  await Promise.all([
    api.call('GET', `stores/${props.id}?included=membership_tier_store_pairs`),
    api.call('GET', 'membership_tiers')
  ])
  loading.value = false
})

const toggleTier = tier => {
  const pairs = mapRelationships(store.value?.relationships.membership_tier_store_pairs.data)
  const pair = pairs.find(x => x.attributes.membership_tier_id.toString() === tier.id)

  if (pair) {
    api
      .call('PUT', `stores/${props.id}?included=membership_tier_store_pairs`, {
        store: {
          membership_tier_store_pairs_attributes: [
            {
              id: pair.id,
              _destroy: true
            }
          ]
        }
      })
      .then(() => {
        waiting.value[tier.id] = false
      })
  } else {
    api
      .call('PUT', `stores/${props.id}?included=membership_tier_store_pairs`, {
        store: {
          membership_tier_store_pairs_attributes: [
            {
              membership_tier_id: tier.id
            }
          ]
        }
      })
      .then(() => {
        waiting.value[tier.id] = false
      })
  }
  waiting.value[tier.id] = true
}

const tierActive = tier => {
  const pairs = mapRelationships(store.value?.relationships.membership_tier_store_pairs.data)
  const result = pairs.some(x => x.attributes.membership_tier_id.toString() === tier.id)
  if (waiting.value[tier.id]) {
    return !result
  } else {
    return result
  }
}

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_unref(NeueLoading), { loading: loading.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SettingsSection, {
          title: "Membership tiers",
          description: "Which tiers a customer can join from this store's checkout. Click a tier to edit it in a new tab."
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tiers.value, (tier) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: tier.id,
                to: '/store/membership-tiers/' + tier.id,
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NeueToggle), {
                    "model-value": tierActive(tier),
                    name: tier.attributes.tier_name,
                    description: tier.attributes.description,
                    disabled: waiting.value[tier.id],
                    "onUpdate:modelValue": $event => (toggleTier(tier))
                  }, null, 8, ["model-value", "name", "description", "disabled", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128)),
            (!tiers.value.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, " You have no membership tiers yet. Create one under Sell to offer it here. "))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

}